import React from 'react'
import n1 from '../im/latest_news/news-thumb1.png'
import n2 from '../im/latest_news/news-thumb2.png'
import n3 from '../im/latest_news/news-thumb3.png'
import n4 from '../im/latest_news/news-thumb4.png'
import n5 from '../im/latest_news/news-thumb5.png'
import n6 from '../im/latest_news/news-thumb6.png'
import n7 from '../im/latest_news/news-thumb7.png'




function Latest_News() {
    return (
        <div>
            <h1 className='display-5 fw-bolder headd p-5 '> <span className='text-light'>Latest </span> <span className='text-primary'> New</span><span className='text-info'>s</span></h1>



            <div className=''>
                <div className='row p-5'>

                    <div className='col-lg-4  col-sm-12 col-md-6  mt-5 hover-item'>

                        <div className='col-12 border rounded-9 '>
                            <div className='rounded-9'>


                                <img src={n1} className='rounded-9 img-fluid '></img>
                                <div className='col-lg-2 col-md-4 col-sm-2 border p-1 rounded-9 ln-mar mx-4 bg-black' ><a href="" className='p-1'>Guides</a> </div>










                            </div >
                            <div className='mx-4'>



                            </div>


                            <div className='p-3 text-light'>

                                <h6 >by Cryptoki, March 26th, 2021</h6>

                                <h4 className='lh'>We explain with details everything you need to know about crypto art and cryptocurrencies!</h4>

                                <h6 className='lh'>A cryptocurrency is a digital asset designed to work as a medium of exchange wherein individual coin ownership records...</h6>

                                <h6 className='fw-bolder'>Read More   <i class="fas fa-greater-than mx-1"></i> </h6>
                            </div>







                        </div>



                    </div>
                    <div className='col-lg-4  col-sm-12 col-md-6  mt-5  hover-item '>

                        <div className='col-12 border rounded-9 '>
                            <div className='rounded-9'>


                                <img src={n2} className='rounded-9 img-fluid '></img>
                                <div className='col-lg-2 col-md-4 col-sm-2 border p-1 rounded-9 ln-mar mx-4 bg-black' ><a href="" className='p-1'>Guides</a> </div>










                            </div >
                            <div className='mx-4'>



                            </div>


                            <div className='p-3 text-light'>

                                <h6 >by Cryptoki, March 26th, 2021</h6>

                                <h4 className='lh'>We explain with details everything you need to know about crypto art and cryptocurrencies!</h4>

                                <h6 className='lh'>A cryptocurrency is a digital asset designed to work as a medium of exchange wherein individual coin ownership records...</h6>

                                <h6 className='fw-bolder'>Read More   <i class="fas fa-greater-than mx-1"></i> </h6>
                            </div>







                        </div>



                    </div>
                    <div className='col-lg-4  col-sm-12 col-md-6  mt-5 hover-item '>

                        <div className='col-12 border rounded-9 '>
                            <div className='rounded-9'>


                                <img src={n3} className='rounded-9 img-fluid '></img>
                                <div className='col-lg-2 col-md-4 col-sm-2 border p-1 rounded-9 ln-mar mx-4 bg-black' ><a href="" className='p-1'>Guides</a> </div>











                            </div >
                            <div className='mx-4'>



                            </div>


                            <div className='p-3 text-light'>

                                <h6 >by Cryptoki, March 26th, 2021</h6>

                                <h4 className='lh'>We explain with details everything you need to know about crypto art and cryptocurrencies!</h4>

                                <h6 className='lh'>A cryptocurrency is a digital asset designed to work as a medium of exchange wherein individual coin ownership records...</h6>

                                <h6 className='fw-bolder'>Read More   <i class="fas fa-greater-than mx-1"></i> </h6>
                            </div>







                        </div>



                    </div>

                </div>

            </div>




       

          











        </div>
    )
}

export default Latest_News
